/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://0ox6nxtmbb.execute-api.eu-central-1.amazonaws.com/cgi",
            "region": "eu-central-1"
        },
        {
            "name": "CreatePublicEvaluationApi",
            "endpoint": "https://ywp0bwmcvi.execute-api.eu-central-1.amazonaws.com/cgi",
            "region": "eu-central-1"
        },
        {
            "name": "EvaluationRequestApi",
            "endpoint": "https://972s6uklx4.execute-api.eu-central-1.amazonaws.com/cgi",
            "region": "eu-central-1"
        },
        {
            "name": "UpdateAssessmentState",
            "endpoint": "https://8zjb2qabmh.execute-api.eu-central-1.amazonaws.com/cgi",
            "region": "eu-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://yh3i7ppp3vgb3b7oicsa67hnrq.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-klyjngi4bvbxnmu6k3z2v3xs6i",
    "aws_cognito_identity_pool_id": "eu-central-1:2d80ba2c-9990-4da6-aa20-94cf4e31722b",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_vEKnNamfY",
    "aws_user_pools_web_client_id": "2jra77sqlbdv5dfn267vfgbuva",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "healthcheck36092999ad3c82342e0bc1950d89d3c9fc9001c5-cgi",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
